ieCarouselInit = function(){
	$("#carousel-container").addClass("ie-carousel");

	var carouselItems = $("figure");

	$("figure").addClass("full-opacity");

	for(i=1; i<carouselItems.length; i++){

		$(carouselItems[i]).addClass("hidden");
	}
	$("#previous").click( function(){
		toggleCarousel("prev");
		highlightNav(-1);
	});
	$("#next").click( function(){
		toggleCarousel("next");
		highlightNav(1);
	});


	 $("#menuDiv figure").click(function(event) {

        var hash = event.currentTarget.getAttribute("data-url");
        var url = "";
        if(window.location.href.indexOf("#") == -1) {
          url = window.location.href + "#" + hash;
        }
        else {
          url = window.location.href + hash;
        }
        window.open(url, "_self");
        window.location.reload();
    });


    $(".carousel-navigation .carouselCircle").click(function(event){
      	var index = parseInt(event.currentTarget.getAttribute("data-index"));
      	var carouselItems = $("figure");
      	var items = $(".carouselCircle");

      	for(j=0; j<items.length; j++){
      		$(items[j]).context.parentElement.className = "selectedCircle";
      		if(j != index){
        		$(items[j]).context.parentElement.className ="";
      		}
  		}

  		for(i=0; i<carouselItems.length; i++){

			if(i === index){
				$(carouselItems[i]).removeClass("hidden");
			}else{
				$(carouselItems[i]).addClass("hidden");
			}
		}

    });

};

toggleCarousel = function(iterateDirection){
	var index = 0;
	var carouselItems = $("figure");
	for(i=0; i<carouselItems.length; i++){
		if(!$(carouselItems[i]).hasClass("hidden")){
			index = i;
		}
	}

	if(iterateDirection == "prev"){
		index = index + 1;
	}
	else{
		index = index - 1;
	}

	if(index > 7){
		index = 0;
	}
	if(index < 0){
		index = 7;
	}

	for(j=0; j<carouselItems.length; j++){
		$(carouselItems[j]).removeClass("hidden");
		if(j != index){
			$(carouselItems[j]).addClass("hidden");
		}
	}
};


highlightNav = function(iterateDirection){
    var index = 0;
    var items = $(".carouselCircle");

    for(i=0; i<items.length; i++){
      if($(items[i]).context.parentElement.className == "selectedCircle"){
        index = i;
      }
    }

    if(iterateDirection == -1){
      index = index - 1;
    }
    else{
      index = index + 1;
    }

    if(index > 7){
      index = 0;
    }
    if(index < 0){
      index = 7;
    }

    for(j=0; j<items.length; j++){
      $(items[j]).context.parentElement.className = "selectedCircle";
      if(j != index){
        $(items[j]).context.parentElement.className ="";
      }
  	}
 }
